import React, { createContext, useContext } from 'react'
import useStatusChecker from '../hooks/useStatusChecker'

const BannerStatusContext = createContext({
  initialData: null,
})

const useBannerStatusContext = () => {
  const context = useContext(BannerStatusContext)
  if (!context) {
    throw new Error('useBannerStatusContext must be used within a Provider')
  }
  return context
}

const BannerStatusProvider = ({ children, locale, tenant }) => {
  const init = useStatusChecker(tenant, locale, null)
  return (
    <BannerStatusContext.Provider
      value={{
        initialData: init.data,
      }}
    >
      {children}
    </BannerStatusContext.Provider>
  )
}

export { BannerStatusContext, useBannerStatusContext, BannerStatusProvider }
